import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField
} from '@material-ui/core';
import { red } from "@material-ui/core/colors";
import { useSnackbar } from "notistack";
import api from "utils/API";
import TableComponent from "views/Widgets/Common/TableComponent";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import ModalDeleteItemTable from "components/PatientFile/ModalDeleteItemTable";
import DetailSelect from "views/Widgets/FichaPaciente/detailSelect";
import MedicalTableComponent from "views/PatientFile/InsumosYMedicamentos/MedicalTableComponent";
import ResourceTableComponent from "views/PatientFile/InsumosYMedicamentos/ResourceTableComponent";
import DocumentosAdjuntosTarea from "components/ClinicalRequests/DocumentosAdjuntosTarea";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import NumberFormat from "react-number-format";
import {firstChartUpperString, toMoneyFormat} from "utils/formatFunctions"
// import TableSummary from "./TableSummary";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    position: "absolute",
    width: "60%",
    height: "80%",

    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  table: {
    minWidth: 650
  }
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};


const detectType = (value, key) => {
  if (key.toLowerCase().includes("fecha")) {
      return moment(value).format("YYYY-MM-DD")
  } else if (key.toLowerCase().includes("valor")) {
      return toMoneyFormat(value)
  } else if (typeof(value) === "number"){
      return value
  } else if ( typeof(value) === "boolean"){
      return value ? "Verdadero" : "Falso"
  }
  return firstChartUpperString(value)
}

function CardObject({obj, title}){
  const classes = useStyles();

  const listKey = Object.keys(obj).map((key) => {
      let tempKeyName = key.split("_").join(" ")
      return {"key": key, "label": firstChartUpperString(tempKeyName)}
  })

  return (
  <Grid item container direction="row" justify="center" alignItems="center" xs={12} style={{margin: "10px 0"}}>
      <Card  className={classes.root} >
          <CardHeader title={`${title} - Información`} />
          <CardContent>
          <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={12}>
              {listKey.map((key) => (
                  <Grid item container direction="row" justify="flex-start" alignItems="flex-start"  xs={6}>
                      <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={6}>
                          <Typography component="body2" variant="body2"  style={{fontWeight: 'bold'}}>
                              {`${key["label"]}:`}
                          </Typography>
                      </Grid>
                      <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={6}>
                          <Typography component="body2" variant="body2">
                              {detectType(obj[key["key"]] || "-", key["key"])}
                          </Typography>

                      </Grid>
                  </Grid>
              ))}
          </Grid>
          </CardContent>
      </Card>
  </Grid>
  )
}

const ModalManagerRequestAntibiotic = props => {
  const classes = useStyles();
  const { openModal, closeModal, tempRow, setinitialCharge } = props;
  const [firstCharge, setFirstCharge] = useState(true);

  const [antibioticData, setantibioticData] = useState({});
  const [dataMedicalArray, setDataMedicalArray] = useState([]);
  const [dataResourceArray, setDataResourceArray] = useState([]);
  const [listProfesional, setlistProfesional] = useState([]);
  const [openDeleteModal, setopenDeleteModal] = useState(null);
  const [sending, setSending] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [rejecting, setRejecting] = useState(false);

  const listCharges = useSelector(state => state.currentList.listCharges);
  const dictCharges = useSelector(state => state.currentList.dictCharges);
  const listTypeTime = useSelector(state => state.currentList.LISTA_TIPO_TIEMPO_PERSONAL_TRATAMIENTO);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = key => (
    <Button style={{background: "#af4c4c00",  color: "#fff"}} onClick={() => {closeSnackbar(key)}}>
        CERRAR
    </Button>
  );

  const handleSnakeMessage = (message, variant) => {
    enqueueSnackbar(message, {
      variant,
      action,
      preventDuplicate: true,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  };

  useEffect(() => {
    if (firstCharge) {
      initialCharge();
    }
  });

  const initialCharge = () => {
    setFirstCharge(false);
    const getRequestAntibiotic = api.get(
      `/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/tratamiento/antibiotico/${tempRow.id_solicitud_paciente.id}/`
    );
    Promise.all([getRequestAntibiotic]).then(response => {
        setantibioticData(response[0].data.tratamiento_antibiotico)
        setlistProfesional(response[0].data.lista_cargos)

        const tempMedicalArray = [];
        const tempResourceArray = [];
        response[0].data.lista_insumos.map(row => {
          const item = {
            id: row.id_insumo_medicamento_id,
            item: row.id_insumo_medicamento__descripcion_producto,
            sku: row.id_insumo_medicamento__SKU,
            cantidad: row.cantidad_necesaria,
          };
          if (row.id_insumo_medicamento__grupo_producto === "Medicamentos") {
            tempMedicalArray.push(item);
          } else {
            tempResourceArray.push(item);
          }
        });
        setDataMedicalArray(tempMedicalArray);
        setDataResourceArray(tempResourceArray);
      }).catch(() => {
        handleSnakeMessage("No se pudo cargar la información de la solicitud", "error");
      })

  };

  const handleSend = () => {
    if (sending) {
      return;
    }
    setSending(true);
    const listaInsumos = [...dataMedicalArray, ...dataResourceArray].map(row => ({
      cantidad_necesaria: row.cantidad,
      id_insumo_medicamento_id: row.id,
    }));
    const body =  {tareas_paciente: listProfesional, lista_insumos: listaInsumos}
    api.put(`/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/tratamiento/antibiotico/${tempRow.id_solicitud_paciente.id}/tarea/${tempRow.id}/`, body).then(responseFile => {
      handleSnakeMessage("Solicitud de tratamiento antibiótico aceptada", "success");
      if (setinitialCharge) {
        setinitialCharge(true);
        closeModal();
      } else {
        window.location.reload();
      }
    }).catch(() => {
      handleSnakeMessage("No se pudo aceptar la solicitud. Intente nuevamente.", "error");
      setSending(false);
    })

  };

  const handleReject = () => {
    if (rejecting) {
      return;
    }
    setRejecting(true);
    api.delete(`/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/tratamiento/antibiotico/${tempRow.id_solicitud_paciente.id}/tarea/${tempRow.id}/`).then(() => {
      handleSnakeMessage("Solicitud de tratamiento antibiótico rechazada", "success");
      setOpenRejectModal(false);
      if (setinitialCharge) {
        setinitialCharge(true);
        closeModal();
      } else {
        window.location.reload();
      }
    }).catch(() => {
      handleSnakeMessage("No se pudo rechazar la solicitud. Intente nuevamente.", "error");
      setRejecting(false);
    })
  };

  const handleUpdateAmount = (value, index) => {
    const tempList = [...listProfesional];
    tempList[index].valor_atencion = value;
    setlistProfesional(tempList);
  }

  // fecha_hora viaja como hora local "naive" (sin zona); se arma/edita en modo UTC
  // para que los números mostrados/enviados coincidan con lo ingresado, sin
  // desplazamiento por la zona horaria del navegador (mismo criterio que la
  // lectura de la tabla más abajo y que el PUT de aceptación, que parsea
  // "%Y-%m-%dT%H:%M:%SZ").
  const roundToHalfHour = (date) => {
    const tempDate = moment.utc(date);
    const remainder = tempDate.minute() % 30;
    if (remainder < 15) {
      tempDate.subtract(remainder, 'minutes');
    } else {
      tempDate.add(30 - remainder, 'minutes');
    }
    tempDate.seconds(0);
    return tempDate;
  }

  const handleAddProffesional = () => {
    const tempList = [...listProfesional];
    const tempDate = roundToHalfHour(moment.utc(moment().format("YYYY-MM-DDTHH:mm:ss")));
    tempList.push({
      id_cargo_id: null,
      id_cargo__nombre_corto: "",
      id_cargo__area: null,
      tipo: listTypeTime?.[0]?.value || "Especifico",
      fecha_hora: tempDate.format("YYYY-MM-DDTHH:mm:ss[Z]"),
      valor_atencion: 0,
    });
    setlistProfesional(tempList);
  }

  const handleUpdateCharge = (value, index) => {
    const tempList = [...listProfesional];
    const cargo = dictCharges[value.value];
    tempList[index].id_cargo_id = value.value;
    tempList[index].id_cargo__nombre_corto = value.label;
    tempList[index].id_cargo__area = cargo?.area;
    setlistProfesional(tempList);
  }

  const handleUpdateType = (value, index) => {
    const tempList = [...listProfesional];
    tempList[index].tipo = value.value;
    setlistProfesional(tempList);
  }

  const handleUpdateDate = (value, index) => {
    const tempList = [...listProfesional];
    // El picker puede devolver un moment en modo local: se renderiza a texto y se
    // vuelve a parsear en modo UTC (en vez de convertir el moment existente) para
    // no desplazar la hora por la zona horaria del navegador.
    const naiveValue = moment.utc(moment(value).format("YYYY-MM-DDTHH:mm:ss"));
    const tempDate = roundToHalfHour(naiveValue);
    tempList[index].fecha_hora = tempDate.format("YYYY-MM-DDTHH:mm:ss[Z]");
    setlistProfesional(tempList);
  }

  const handleDeleteRow = () => {
    const index = openDeleteModal.index;
    const tempList = listProfesional.filter((row, tempIndex) => index !== tempIndex);
    setlistProfesional(tempList);
    setopenDeleteModal(null);
  }

  const headersProff = [
    {label: "Cargo"},
    {label: "Tipo"},
    {label: "Fecha/hora"},
    {label: "Valor"},
    {label: "Acción"},
  ];

  const dataProff = listProfesional.map((row, index) => {
    const _amount_ =  <TextField
      label=""
      value={row.valor_atencion || 0}

      onChange={e => handleUpdateAmount(parseInt(e.target.value), index)}
      name="numberformat"
      id="formatted-numberformat-input"
      InputProps={{
        inputComponent: NumberFormatCustom
      }}
    />

    const _charge_ = <DetailSelect
      value={row.id_cargo_id ? {value: row.id_cargo_id, label: row.id_cargo__nombre_corto} : null}
      onchange={value => handleUpdateCharge(value, index)}
      list={listCharges}
    />

    const _type_ = <DetailSelect
      value={listTypeTime?.find(option => option.value === row.tipo) || null}
      onchange={value => handleUpdateType(value, index)}
      list={listTypeTime}
    />

    // fecha_hora viaja como hora local "naive" (sin zona) desde la creación;
    // se parsea/edita en UTC para mostrarla y guardarla tal cual se ingresó,
    // sin desplazamiento del navegador
    const _date_ = <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
      {row.tipo === "Repetido" ? <KeyboardTimePicker
        label={"Hora a repetir"}
        variant="inline"
        format="HH:mm"
        margin="normal"
        onChange={value => handleUpdateDate(value, index)}
        value={moment.utc(row.fecha_hora)}
        inputVariant={"outlined"}
        minutesStep={30}
      /> :
      <KeyboardDateTimePicker
        label={"Fecha y hora"}
        variant="inline"
        format="DD/MM/YYYY HH:mm"
        margin="normal"
        onChange={value => handleUpdateDate(value, index)}
        value={moment.utc(row.fecha_hora)}
        inputVariant={"outlined"}
        minutesStep={30}
      />
      }
    </MuiPickersUtilsProvider>

    const _delete_ = <Button
      variant="outlined"
      style={{
        color: red[500],
        borderColor: red[500],
      }}
      onClick={() => setopenDeleteModal({row, index: index})}
    >
      Eliminar
    </Button>

    return [
      {_value_: _charge_},
      {_value_: _type_},
      {_value_: _date_},
      {_value_: _amount_},
      {_value_: _delete_},
    ]
  })


  const _content_ =  <Grid item container xs={12} justify="center">
      <Grid container className={classes.root} justify="center">
        <Grid
          item
          container
          xs={12}
          direction="column"
          justify="center"
          alignContent="center"
          spacing={1}
        >
          <CardObject obj={antibioticData} title={"TTO"}/>
        </Grid>
      </Grid>
      <Grid item container xs={12}>
        <Typography variant="subtitle1" style={{fontWeight: "bold", margin: "8px 0"}}>
          Medicamentos
        </Typography>
        <MedicalTableComponent
            dataMedicalArray={dataMedicalArray}
            setDataMedicalArray={setDataMedicalArray}
            setPageRefresh={() => {}}
        />
      </Grid>
      <Grid item container xs={12}>
        <Typography variant="subtitle1" style={{fontWeight: "bold", margin: "8px 0"}}>
          Insumos
        </Typography>
        <ResourceTableComponent
            dataResourceArray={dataResourceArray}
            setDataResourceArray={setDataResourceArray}
            setPageRefresh={() => {}}
        />
      </Grid>
      <Grid item container xs={12} justify="flex-start" style={{margin: "16px 0 0 0"}}>
        <Button
          variant="contained"
          color="primary"
          disabled={listCharges?.length === 0}
          onClick={() => handleAddProffesional()}
        >
          {`Agregar Profesional Extra`}
        </Button>
      </Grid>
      <Grid item container xs={12} justify="center">
        <TableComponent
            headers={headersProff}
            data={dataProff}
        />
      </Grid>
      <DocumentosAdjuntosTarea idTarea={tempRow.id} />
    </Grid>

  const _actions_ = <>
      {!sending && (listProfesional.length == 0 || listProfesional.every((row) => row.valor_atencion > 0 && row.id_cargo_id))?

      <Button
        variant="contained"
        style={{
          backgroundColor: "#43a047",
          textTransform: "none",
          color: "#fff"
        }}
        onClick={() => handleSend()}
      >
        Aceptar solicitud
      </Button> :
      <Button
        variant="contained"
        disabled
      >
        {sending ? "Aceptando..." : "Aceptar solicitud"}
      </Button>
      }
      <Button
        variant="outlined"
        disabled={sending}
        style={{
          color: red[500],
          borderColor: red[500],
          textTransform: "none"
        }}
        onClick={() => setOpenRejectModal(true)}
      >
        Rechazar solicitud
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{
          textTransform: "none"
        }}
        onClick={closeModal}
      >
        Atrás
      </Button>
  </>

  const _rejectContent_ = <Typography variant="body2">
    ¿Estás seguro que deseas rechazar esta solicitud de tratamiento antibiótico? Esta acción no se puede deshacer.
  </Typography>

  const _rejectActions_ = <>
    <Button
      variant="contained"
      color="primary"
      disabled={rejecting}
      onClick={() => setOpenRejectModal(false)}
    >
      Cerrar
    </Button>
    <Button
      variant="contained"
      style={{ backgroundColor: red[500], color: "#fff" }}
      disabled={rejecting}
      onClick={handleReject}
    >
      {rejecting ? "Rechazando..." : "Rechazar solicitud"}
    </Button>
  </>

  return (
    <>
    <ModalDialog
        open={openModal}
        onClose={closeModal}
        title={`Información Tratamiento Antibiótico`}
        _content_={_content_}
        _actions_ = {_actions_}
        maxWidth="xl"
    />
    {openDeleteModal && (
    <ModalDeleteItemTable
      open={!!openDeleteModal}
      handleClose={() => setopenDeleteModal(null)}
      handleDelete={handleDeleteRow}
      title={`Eliminar profesional ${openDeleteModal.row.id_cargo__nombre_corto || ""}`}
    />
    )}
    {openRejectModal && (
    <ModalDialog
      open={openRejectModal}
      onClose={() => setOpenRejectModal(false)}
      title={`Rechazar solicitud`}
      _content_={_rejectContent_}
      _actions_={_rejectActions_}
      maxWidth="xs"
    />
    )}
    </>
  );
};

export default ModalManagerRequestAntibiotic;

ModalManagerRequestAntibiotic.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
  tempRow: PropTypes.object
};
